/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endtoend_Vapid_DeliveryInputs */

const en_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End-to-End VAPID Delivery`)
};

const es_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega VAPID de extremo a extremo`)
};

const fr_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison VAPID de bout en bout`)
};

const de_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End-to-End VAPID-Zustellung`)
};

const ja_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンドツーエンドVAPID配信`)
};

const zh_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`端到端 VAPID 交付`)
};

const ar_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم VAPID من طرف إلى طرف`)
};

const id_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiriman VAPID End-to-End`)
};

const it_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consegna VAPID End-to-End`)
};

const ru_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сквозная доставка VAPID`)
};

const pt_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega VAPID de Ponta a Ponta`)
};

const ko_endtoend_vapid_delivery = /** @type {(inputs: Endtoend_Vapid_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종단 간 VAPID 전송`)
};

/**
* | output |
* | --- |
* | "End-to-End VAPID Delivery" |
*
* @param {Endtoend_Vapid_DeliveryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const endtoend_vapid_delivery = /** @type {((inputs?: Endtoend_Vapid_DeliveryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endtoend_Vapid_DeliveryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_endtoend_vapid_delivery(inputs)
	if (locale === "es") return es_endtoend_vapid_delivery(inputs)
	if (locale === "fr") return fr_endtoend_vapid_delivery(inputs)
	if (locale === "de") return de_endtoend_vapid_delivery(inputs)
	if (locale === "ja") return ja_endtoend_vapid_delivery(inputs)
	if (locale === "zh") return zh_endtoend_vapid_delivery(inputs)
	if (locale === "ar") return ar_endtoend_vapid_delivery(inputs)
	if (locale === "id") return id_endtoend_vapid_delivery(inputs)
	if (locale === "it") return it_endtoend_vapid_delivery(inputs)
	if (locale === "ru") return ru_endtoend_vapid_delivery(inputs)
	if (locale === "pt") return pt_endtoend_vapid_delivery(inputs)
	return ko_endtoend_vapid_delivery(inputs)
});